// import React, {Component} from 'react';

// class RosterEdit extends Component {
// 	render() {
// 		console.log('props', this.props);
// 		return (
// 			<p>Hello World</p>
// 		)
// 	}
// }

// export default RosterEdit

import React, { Component, Fragment } from 'react';
import { Box, Button, Flex, Heading, Text } from 'rebass';
import { connect } from 'react-redux';
import { searchActions, searchSelectors } from "../../store/search";
import { chatActions } from "../../store/chat";

import { schoolSelectors } from "../../store/school";

import { Content, DesktopBox, MobileHeader, PositionBox, Toolbar } from "../../components/Base";

import UserList from '../../components/UserList'
import Loading from '../../components/Base/Loading'
import { ColumnIcon, GridIcon } from "../../components/Base/Icons";
import { withRouter } from "react-router";
import ApplyFilter from '../../components/Search/ApplyFilters'
import FilterDropdown from "../../components/Search/FilterDropdown";
import BasicSearch from '../../components/Forms/BasicSearch'
import '../../resources/css/fab.css';
import { filterStudentsByName } from "../../utils";
import { SidebarWrapper } from './styles'
import { uniq } from 'lodash-es'


class RosterEdit extends Component {

	state = {
		name: '',
		columnView: false,
		detailsView: false,
		currentStudent: null,
		roster: [],
		selected: [],
		allStudents: [],
		rosterStudents: [],
		mobileDetails: false,
		edit: true,
		checkin: false,
		share: false,
		chat: false,
		wave: false,
		confirmDelete: false,
		recentCheckin: null,
		openRecentCheckin: false,
		isLoading: false,
		beforeSelected: [],
		search: ''
	};

	componentDidMount() {
		this.props.clearSearch();
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			selected: nextProps.selected,
			beforeSelected: [...nextProps.selected]
		});
	}

	handleEditSelect = (details) => {
		let { selected } = this.state;
		// console.log('selected for roster', details)
		let contains = false;
		for (var i = selected.length - 1; i >= 0; i--) {
			if (selected[i] === details.id) {
				selected.splice(i, 1);
				contains = true;
				this.setState({ selected })
				// break;       //<-- Uncomment  if only the first term has to be removed
			}
		}

		if (!contains) {
			selected.push(details.id);
			this.setState({ selected })
		}

	};


	// Sets User list view to grid (table) or column (collection) view
	setPageView = (isColumn) => {
		this.setState({ columnView: isColumn })
	};

	// Toggles showing Student Summary
	toggleDetailsView = () => {
		this.setState({ detailsView: !this.state.detailsView })
	};

	toggleActionMode = (action) => {
		this.setState({ [action]: !this.state[action] })
	};

	handleSaveEdit = async () => {
		const { selected, beforeSelected } = this.state;
		const { roster, firebase, history, rosterName } = this.props;
		let beforeSelectedData = [...beforeSelected];
		try {
			let rosterRef = await firebase.roster(roster.id);
			//let chatsRef = await firebase.chats().get();
			let chatsRef = await firebase.chats().where('custom_id', '==', rosterName.toLowerCase() + '-roster').get();
			
			let allData = chatsRef.docs.map(doc => {
				return { id: doc.id, data: doc.data() }
			});

			//let filteredData = allData.filter(obj => obj.data.custom_id != null && obj.data.custom_id.includes(rosterName.toLowerCase() + '-roster'));
			allData.forEach(obj => {
				let currentObjectMember = [...obj.data.members];
				let removedOldMember = currentObjectMember.filter(item => beforeSelectedData.indexOf(item) === -1);
				let newMember = uniq([...removedOldMember, ...selected, ...roster.shared_with]);
				firebase.chat(obj.id).update({
					members: newMember
				});
			});

			rosterRef.update({
				students_uid: selected
			}).then(() => {
				history.push('/app/search');
			});
		} catch (e) {
			//console.log('error', e)
		}
	};

	handleCancel = () => {
		this.props.history.goBack();
	}

	handleSearchChange = (e) => {
		this.setState({search: e.target.value});
	}

	render() {
		const { columnView, detailsView, search } = this.state;
		const { roster, schoolInfo, filters, clearFilter } = this.props;
		let showToolbar = true;
		if (detailsView) {
			showToolbar = false;
		}
		if (columnView) {
			showToolbar = true;
		}
		let count = 0;
		if (roster !== null && roster.students_uid !== undefined) {
			count = roster.students_uid.length
		}
		return (
			<Box>
				{/* MOBILE HEADER */}
				<MobileHeader paddingLeft={'0px'} paddingRight={'0px'}>
					<Box px={'24px'} pb={'10px'}>
						<Heading pt={2}>{`${roster.name} (${count})`}</Heading>
						<ApplyFilter filters={filters} clearFilter={clearFilter} school={schoolInfo} />
					</Box>
					<BasicSearch handleInput={this.handleSearchChange} search={search} placeholder={'Search Students'}/>
				</MobileHeader>

				{/*<FocusLock>*/}

				<Content>
					<Box ml={[0, '50%', '70%']}>
					</Box>
					<DesktopBox>
						<Flex>
							{showToolbar &&
								<Box pl={3} mb={1} pt={2} width={1/2}>
									<Toolbar p={2} bg={'white'} boxShadow={['none', 'main']}>

										<Box css={{ display: 'inline-block' }} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
											color={'meta'}>VIEW</Text></Box>
										<Box bg={'transparent'} ml={3} py={2} onClick={() => this.setState({ columnView: false })}>
											<GridIcon color={!columnView ? 'black' : '#969a9b'} />
										</Box>
										<Box ml={2} py={2} onClick={() => this.setState({ columnView: true })}>
											<ColumnIcon color={columnView ? '#00000' : '#969a9b'} />
										</Box>

										<Box css={{ display: 'inline-block' }} ml={5}><Text fontSize={0} fontWeight={700} py={2} mt={'3px'}
											color={'meta'}>FILTER</Text></Box>
										<Box ml={3}>
											<FilterDropdown school={schoolInfo} filters={filters} clearFilter={clearFilter} />
										</Box>

									</Toolbar>
								</Box>
							}
							<Box ml={'auto'}/> 
							<Box  pt={3} pr={'8px'} width={[ 2/5]}>
								<BasicSearch handleInput={this.handleSearchChange} search={search} placeholder={'Search Students'}/>
							</Box>
						</Flex>
						
					</DesktopBox>
					{this.renderStudentSummary()}
					<PositionBox bg={'white'} position={'fixed'} bottom={0} left={0} width={'100%'} boxShadow={'main'} p={0}
						m={0}>
						<Flex justifyContent={'center'} p={2}>

							<Button variant={'main'} bg={'green'} onClick={this.handleSaveEdit}>Save</Button>
							<Button variant={'main'} bg={'red'} ml={1} onClick={this.handleCancel}>Cancel</Button>
						</Flex>
					</PositionBox>

				</Content>
				{/*</FocusLock>*/}
			</Box>
		)
	}

	renderStudentSummary = () => {
		const { columnView, selected, isLoading, search } = this.state;
		const { students, loading, currentList } = this.props;
		let listProps = {
			width: [1, 1 / 4],
		};
		if (!columnView) {
			listProps = {
				width: 1,
			}
		}

		let showUserList = true;
		let searchList = currentList;

		if (search !== null && students.length > 0) {
			searchList = filterStudentsByName(searchList, search)
		}
		return (
			<Fragment>
				{(loading || isLoading) ? <Loading /> :
					<Flex width={1}>
						{showUserList &&
							<Box {...listProps}>
								<SidebarWrapper boxShadow={['none', columnView ? 'inset' : 'none']} pb={[50, 0]} pt={[0, '10px']}>
									<UserList
										students={searchList}
										handleUserClick={this.handleEditSelect}
										withLocation
										columnView={columnView}
										selected={selected}
									/>
								</SidebarWrapper>
							</Box>}
					</Flex>}
			</Fragment>
		)
	}
}

const mapStateToProps = state => ({
	schoolInfo: schoolSelectors.refreshSchool(state.school),
	filters: searchSelectors.refreshFilters(state.search),
	students: searchSelectors.refreshCurrentResults(state.search),
	placeholder: searchSelectors.refreshPlaceholder(state.search)
});

const mapDispatchToProps = dispatch => ({
	clearFilter: () => {
		dispatch(searchActions.clearFilter());
	},
	updateStudents: (students) => {
		dispatch(searchActions.updateStudents(students))
	},
	updateCurrentChat: (id) => {
		dispatch(chatActions.updateCurrentChat(id))
	}
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RosterEdit))